import SyncWithPlayerOnDemandStrategy from './SyncWithPlayerOnDemandStrategy';

export default SyncWithPlayerOnDemandStrategy;
